import { AllPurposeLink } from '@components/all-purpose-link'
import { HeadlineText, JumboText, BodyText, DisplayText } from 'design-configuration/components'
import React from 'react'
import ReactMarkdown, { Components } from 'react-markdown'

type MarkdownDisplayProps = {
  children?: string | null
  className?: string
  componentOverrides?: Components
}

export const MarkdownDisplay = ({
  children,
  className,
  componentOverrides
}: MarkdownDisplayProps): React.ReactElement => {
  return (
    <div className={className}>
      <ReactMarkdown
        disallowedElements={['img']}
        components={{
          h1: (props) => <JumboText>{props.children}</JumboText>,
          h2: (props) => <DisplayText>{props.children}</DisplayText>,
          h3: (props) => <DisplayText>{props.children}</DisplayText>,
          h4: (props) => <HeadlineText>{props.children}</HeadlineText>,
          h5: (props) => <HeadlineText>{props.children}</HeadlineText>,
          h6: (props) => <HeadlineText>{props.children}</HeadlineText>,
          a: (props) => (
            <AllPurposeLink href={props.href ? props.href : ''} className="not-italic underline">
              {props.children}
            </AllPurposeLink>
          ),
          p: (props) => <BodyText className="mb-md last:mb-0">{props.children}</BodyText>,
          ...componentOverrides
        }}
      >
        {children || ''}
      </ReactMarkdown>
    </div>
  )
}
